import { render, staticRenderFns } from "./Familial.vue?vue&type=template&id=ce068038&"
import script from "./Familial.vue?vue&type=script&lang=js&"
export * from "./Familial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports